<app-shortcuts-area></app-shortcuts-area>

<!--
<mat-divider></mat-divider>

<app-ui-settings></app-ui-settings>
-->
